const styles = {
  root: {
    width: '100%',
    height: { xs: 250, lg: 360, xl: 364 },
    backgroundColor: 'background.default',
  },

  confirmationVariant: {
    width: '100%',
    height: { xs: 70 },
    backgroundColor: 'background.default',
    px: 1,
  },

  pin: {
    color: '#DC4F44',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '28px',
    height: '28px',
    userSelect: 'none',
    transform: 'translate(-50%, -50%)',
  },
}

export default styles
